import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const StorageStatusModal = ({ open, handleClose }) => {
  const [storageInfo, setStorageInfo] = useState(null);
  const [currentUsage, setUsage] = useState(0);
  const [currentQuota, setQuota] = useState(0);
  const [persistence, setPersistence] = useState(false);

  useEffect(() => {
    if (open) {
      checkStorageAvailability();
      checkPersistence();
    }
  }, [open]);

  const checkStorageStatus = () => {
    if ("storage" in navigator && "estimate" in navigator.storage) {
      navigator.storage.estimate().then((storageEstimate) => {
        setStorageInfo(storageEstimate);
      });
    }
  };
  async function checkStorageAvailability() {
    try {
      const { usage, quota } = await navigator.storage.estimate();
      console.log(usage, quota);
      setUsage(usage);
      setQuota(quota);

      console.log(`Current storage usage: ${formatBytes(usage)} `);
      console.log(`Storage quota: ${formatBytes(quota)} `);

      const availableSpace = quota - usage;
      console.log(`Available storage space: ${formatBytes(availableSpace)} `);
    } catch (error) {
      console.error("Error checking storage availability:", error);
    }
  }

  const formatBytes = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  async function checkPersistence() {
    let persisted = await navigator.storage.persisted();
    if (persisted) {
      setPersistence(true);
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Storage Status</DialogTitle>
      <DialogContent>
        {true ? (
          <>
            <Typography>Usage: {formatBytes(currentUsage)}</Typography>
            <Typography>Quota: {formatBytes(currentQuota)}</Typography>
            <Typography>Is Persistent: {persistence ? "Yes" : "No"}</Typography>
          </>
        ) : (
          <Typography>Loading storage information...</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StorageStatusModal;
